<template>
    <div ref="searchableInput" class="multiple-select-dropdown" v-click-outside="handleClickOutside">
        <input ref="inputField" class="form-control multiple-select-search" @input="triggerSearch" :placeholder="placeholder" @click="inputClicked" v-model="queryText" />
        <div class="multiple-select-selected">
            <span v-if="selectedValuesDisplay.length === 0" class="none-selected">No selection yet.</span>
            <template v-else>
                <div class="selected-option-wrapper">
                    <div v-for="(option, index) in selectedValuesDisplay" :key="index" class="option-item">
                        <div class="text-nowrap">
                            {{option.text}}
                        </div>
                        <div class="option-delete">
                            <a href="javascript: void(0);" class="delete-button" @click="trashOption(option.value)"><i class="fas fa-trash-alt"></i></a>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div ref="dropdownValues" v-show="isDropdownShown" class="searchable-dropdown-overlay" :style="{
            maxHeight: `${maxHeight}px`,
            width: `${inputWidth}px`
        }">
            <div v-if="queryText.length === 0 && optionListCopy.length === 0" class="searchable-dropdown-item"><span class="font-italic indicator-text">Type something to search...</span></div>
            <div v-else-if="optionListCopy.length === 0 && !isLoading" class="searchable-dropdown-item"><span class="font-italic indicator-text">No result</span></div>
            <div v-else-if="isLoading" class="searchable-dropdown-item"><span class="font-italic indicator-text">Loading results...</span></div>
            <template v-else-if="optionListCopy.length > 0">
                <div class="searchable-dropdown-item" v-for="(option, index) in optionListCopy" :key="index" @click="selectOption(option.value)">
                    <div class="d-flex align-items-center">
                        <input type="checkbox" style="margin-top: 2px" :checked="isSelected(option.value)">
                        <div class="flex-fill ml-2">{{option.text}}</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
export default {
    'name': 'MultipleSelectDropdown',
    'directives': {
        ClickOutside
    },
    'computed': {
        selectedValuesDisplay () {
            let list = [];

            this.selectedList.forEach((item) => {
                let selectedFullDetails = this.options.find((o) => o.value === item);

                if (selectedFullDetails) {
                    list.push(selectedFullDetails);
                }
            });

            return list;
        }
    },
    'props': {
        'options': {
            'type': Array,
            default () {
                return [];
            }
        },
        'selectedList': {
            'type': Array,
            default () {
                return [];
            }
        },
        'placeholder': {
            'type': String,
            'default': 'Type to search'
        },
        'isLoading': {
            'type': Boolean,
            'default': false
        },
        'dismissOnSelect': {
            'type': Boolean,
            'default': false
        }
    },
    'watch': {
        isDropdownShown (isShown) {
            this.$nextTick(() => {
                this.$refs.dropdownValues.scrollTop = 0;
            });
        },
        options (optionList) {
            this.optionListCopy = optionList;
        }
    },
    data () {
        return {
            'inputWidth': 0,
            'maxHeight': 400,
            'isDropdownShown': false,
            'optionListCopy': [],
            'queryText': ''
        };
    },
    mounted () {
        this.inputWidth = this.$refs.inputField.clientWidth;

        this.optionListCopy = this.options;
    },
    'methods': {
        refresh () {
            this.$nextTick(() => {
                // allow explicitly update of width
                this.inputWidth = this.$refs.inputField.clientWidth;
            });
        },
        handleClickOutside () {
            let searchableInput = this.$refs.searchableInput;
            let searchableInputNodes = [];
            searchableInputNodes.push(searchableInput);

            searchableInput.childNodes.forEach((node) => {
                searchableInputNodes.push(node);
            });

            if (!(searchableInputNodes.some((dom) => dom === event.target)) && this.isDropdownShown) {
                this.dismissDropdown();
            }
        },
        dismissDropdown () {
            this.isDropdownShown = false;
            this.optionListCopy = this.options;
            this.queryText = '';
        },
        inputClicked () {
            this.$refs.inputField.select();
            this.isDropdownShown = !this.isDropdownShown;
        },
        selectOption (selectedValue) {
            this.$emit('selected', selectedValue);

            if (this.dismissOnSelect) {
                this.dismissDropdown();
            }
        },
        triggerSearch () {
            this.isDropdownShown = true;

            if (this.queryText.length === 0) {
                this.optionListCopy = this.options;
            } else {
                this.optionListCopy = this.options.filter((item) => {
                    let optionText = item.text.toLowerCase();
                    return optionText.indexOf(this.queryText.toLowerCase()) > -1;
                });
            }
        },
        isSelected (optionValue) {
            return !!this.selectedList.find((i) => i === optionValue);
        },
        trashOption (optionValue) {
            this.$emit('selected', optionValue);
        }

    }
};
</script>

<style>
.multiple-select-dropdown {
    border: 1px solid #ced4da;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.multiple-select-dropdown.is-invalid{
      border: 1px solid #dc3545;
}

.multiple-select-dropdown.is-invalid ~.invalid-feedback{
    display: block;
}

.multiple-select-dropdown .multiple-select-search{
    border: none;
}

.multiple-select-dropdown .multiple-select-search:focus,
.multiple-select-dropdown .multiple-select-search:active{
    border: none;
    box-shadow: none;
}

.multiple-select-dropdown .multiple-select-selected{
    border-top: 1px solid #ced4da;
    padding: .75rem;
}

.multiple-select-dropdown .multiple-select-selected .none-selected{
    color: #000;
    font-style: italic;
}

.multiple-select-dropdown .multiple-select-selected .selected-option-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin-right: -.75rem;
    margin-bottom: -.75rem;
}

.multiple-select-dropdown .multiple-select-selected .selected-option-wrapper .option-item {
    margin-right: .75rem;
    margin-bottom: .75rem;
    color: #009344;
    border: 1px solid #009344;
    padding: .375rem .75rem;
    border-radius: .25rem;
    display: flex;
    align-items: center;
}

.multiple-select-dropdown .multiple-select-selected .selected-option-wrapper .option-item .option-delete{
    margin-left: .75rem;
}

.multiple-select-dropdown .multiple-select-selected .selected-option-wrapper .option-item .option-delete a.delete-button{
    display: flex;
    align-items: center;
    justify-content: center;
    color: #dc3545;
    text-decoration: none;
}

.multiple-select-dropdown .searchable-dropdown-overlay{
    margin-top: 3px;
    z-index: 1;
    position: absolute;
    background-color: #fff;
    overflow-y: auto;
    padding: 5px 0;
    border: solid #ccc 1px;
    border-radius: 5px;
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.7);
}

.multiple-select-dropdown .searchable-dropdown-overlay .searchable-dropdown-item{
    padding: 5px 10px;
    display: block;
    text-decoration: none;
    color: initial;
}

.multiple-select-dropdown .searchable-dropdown-overlay .searchable-dropdown-item:hover{
    color: #fff;
    background-color: #009344;
}

.indicator-text {
    color: #9499a8;
}
</style>
